export function jsxRenderer<T extends keyof JSX.IntrinsicElements>(
  type: T,
  props: JSX.IntrinsicElements[T],
  ...children: (Node | string)[]
) {
  const element = document.createElement(type);

  if (props) {
    Object.keys(props).forEach((key) => {
      if (key.startsWith("on")) {
        element.addEventListener(
          key.slice(2).toLowerCase(),
          props[key] as EventListener,
        );
      } else if (key === "ref") {
        props[key].current = element;
      } else {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (element as any)[key] = props[key];
      }
    });
  }

  element.append(...children.filter((child) => !!child));

  return element;
}

window.jsxRenderer = jsxRenderer;
